import { NavigationExtras } from '@angular/router'
import { Action } from '@ngrx/store'

/**
 * Created by sange on 17/08/2017.
 */

export const API_CALL_SUCCESS = '[App] Api call success'
export const API_CALL_FAILURE = '[App] Api call failure'
export const API_CALL_INFO = '[App] Api call info'
export const GO = '[App] Go'
export const BACK = '[App] Back'
export const FORWARD = '[App] Forward'

export class ApiCallSuccess implements Action {
  readonly type = API_CALL_SUCCESS

  constructor(public payload: { title: string, msg: string }) {
  }
}

export class ApiCallFailure implements Action {
  readonly type = API_CALL_FAILURE

  constructor(public payload: { title: string, msg: string }) {
  }
}

export class ApiCallInfo implements Action {
  readonly type = API_CALL_INFO

  constructor(public payload: { title: string, msg: string }) {
  }
}

export class Go implements Action {
  readonly type = GO

  constructor(public payload: {
    path: any[]
    query?: object
    extras?: NavigationExtras
  }) {
  }
}

export class Back implements Action {
  readonly type = BACK
}

export class Forward implements Action {
  readonly type = FORWARD
}

export type Actions =
  ApiCallSuccess
  | ApiCallFailure
  | ApiCallInfo
  | Go | Back | Forward



// WEBPACK FOOTER //
// ./src/app/store/actions/app.actions.ts